import swal from "sweetalert"
import { FETECH_CSV_DATA, FETECH_ACCOUNT, FETECH_BUCKET, FETECH_PROJECT_STATUS, ONEFETECH_ACCOUNT, FETECH_MARKETS, FETECH_USER_ROLE, FETECH_USER_LIST, ONE_USER_ACCOUNT, FETECH_FILTER_USER, FETECH_TECHNOLOGY, FETECH_EQUIPMENT, FETECH_OSS, FETECH_VENDOR, FETECH_SINGLE_PROJECT, FETECH_CREW_COMPANY, FETECH_RAN_DASHBOARD, FETECH_TIMELINE, FETECH_RAN_STATUS, FETECH_NETWORK_SITE_STATUS, FETECH_SITES, FETECH_SITEID, FETECH_CR_NUMBER, FETECH_ADD_CR_NUMBER, FETECH_RAN_TRACKER, FETECH_ALL_DROP_DOWN, FETECH_SINGLE_DROPDOWN, FETECH_PRODUCT_CODE, FETECH_GSM_UTMS, FETECH_RFDS_LIST, FETECH_SINGLE_MOPS, FETECH_PRODUCT_ID, MAGENTA_FETECH_CSV_DATA,INFLIGHT_FETECH_CSV_DATA,NETWORK_DATABASE_FETECH_CSV_DATA, FETECH_TIER_LIST, UPDATE_POP_UP, FETECH_SINGLE_PROJECTDATABASE, FETECH_SINGLE_RAN_PROJECT, FETECH_TT_PROJECT, FETECH_E911_PROJECT, FETECH_RAN_SPILOVER, FETECH_NESTING_TIMELINE, CHART_TIMELINE, FETECH_RAN_NESTING, FETECH_GEO_FENCING, VENDOR_CHART_TIMELINE, DASHBOARD_VENDOR_CHART_TIMELINE, TT_AGING_CHART_TIMELINE, WAR_ROOM_CHART_TIMELINE, GET_ALL_MAP_SITES, SET_LOADER, FETECH_SINGLE_TECH_RAN_PROJECT, CLEAR_FETECH_SINGLE_MOPS, CLEAR_FETECH_SINGLE_RAN_PROJECT,SET_ASSINGNED_ENGINEER, FETECH_SINGLE_IX_PROJECT, FETECH_IX_DASHBOARD, FETECH_RTT_DASHBOARD, FETECH_MOP_STATUS, FETECH_COUNT_DATA, FETECH_CLEAR_RAN_DASHBOARD, FETECH_NEW_E911_PROJECT, FETECH_CLEAR_TT_PROJECT, FETECH_CLEAR_RAN_TRACKER, AWS_CHART_TIMELINE, FETECH_CLEAR_SLA_RAN_TRACKER, FETECH_SLA_RAN_TRACKER, FETECH_RAN_NESTING_REPORT, FETECH_RAN_NESTING_TRACKER, FETECH_CLEAR_RAN_NESTING_REPORT, FETECH_CLEAR_RAN_NESTING_TRACKER,TIME_ZONE, FETECH_MANAGE_UTILIZATION, FETECH_PIER_TT_GROUP, FETECH_72_Alarm, CLEAR_IX_SINGLE_API, FETECH_MOBILE_DATA_COP_TIMELINE,SSV_DASHBOARD, LAUNCH_SSVDASHBOARD, FILTERDROPDOWN, LCL_MOP_DASHBOARD_FILTER, RESET_LCL_MOP_DASHBOARD_FILTER, LCL_RAN_DASHBOARD_FILTER, RESET_LCL_RAN_DASHBOARD_FILTER, RESET_LCL_TT_FILTER, LCL_TT_FILTER, LCL_ENOO_FILTER, RESET_LCL_ENOO_FILTER, LCL_LEXPORT_TT_FILTER, FETECH_TT_STATUS, Get_Last_Saved_Data, Save_Last_Saved_Data, FETECH_MOP_Instruction, AWS_CHART_CALL_TIMELINE, FETECH_SINGLE_A_DROPDOWN, LCL_RAN_SLA_FILTER, FETECH_NEW_RTT_PROJECT, FETECH_RTT_PROJECT, FETECH_NEW_ST_PROJECT, FETECH_ST_PROJECT, FETECH_NEW_IX_PROJECT, FETECH_IX_PROJECT, LCL_LSSV_FILTER, RESET_LCL_SSV_FILTER, RESET_LCL_LSSV_FILTER, LCL_SSV_FILTER, LCL_IX_DASHBOARD_FILTER, RESET_LCL_IX_DASHBOARD_FILTER, LCL_SLA_DASHBOARD_FILTER, RESET_LCL_SLA_FILTER, RESET_LCL_SLA_DASHBOARD_FILTER, LCL_NESTING_FILTER, RESET_LCL_NESTING_FILTER, CHAT_MESSAGE_PENDING, CLEAR_NETWORK_DATABASE_FETECH_CSV_DATA, FUNVENDOR_SCORE_CARD_DASHBOARD, FUNVENDOR_SCORE_CARD, GETBARCHARTDATA  } from "./PostTypes"

import { accountApi, crNumberList, getMarket, listUserApi, listUserApi_two, ossAddApi, ossApi, ranDashboard, updatedevelopment, updateGCpagdata, updatefops, updaterfengineer, mopDataApi, listTmobileUserApi, vendorApi, allTechnologyApi, ranNesting, addCrewCompany, geoFencing, getAllDropDownList, ttCountVendor, dashboardVendor, ttAgingVendor, dashboardCustomer, sitesCountCustomer, sitesAgingCustomer, warRoomActivity, ranDeleteData, networkOneSiteDatabaseprojectId, OneRanTech, changeButtonStatus, ranSiteStatus, ixModule,awsDashboard, ranNesting_report, ranNesting_tracker, timeZoneApi, manageutilizationApi, pierTTGroupapi, updateUser, mobileDatacoptl, SSVDashboard, SSVDashboardAPI, LSSVDashboardAPI, SevenTwoAlarmFetchSingle, addFDatatoran, rfApprovalActionChange, goNoGoAction, mopFilters, ranfilters, ttfilters, bulkUpload, enoofilters, ttDashSiteStatus, userTableData, aws_callLogsdb, MOPInstructionApi, aws_callLogschartdb, ixSiteStatus, nwfilters, commonfilters, VendorScoreCardDashboard, scorecardpiefilters, VendorScoreCardApi  } from "../../common/config"
// import { accountApi, crNumberList, getMarket, listUserApi, listUserApi_two, ossAddApi, ossApi, ranDashboard, updatedevelopment, updateGCpagdata, updatefops, updaterfengineer, mopDataApi, listTmobileUserApi, vendorApi, allTechnologyApi, ranNesting, addCrewCompany, geoFencing, getAllDropDownList, ttCountVendor, dashboardVendor, ttAgingVendor, dashboardCustomer, sitesCountCustomer, sitesAgingCustomer, warRoomActivity, ranDeleteData, networkOneSiteDatabaseprojectId, OneRanTech, changeButtonStatus, ranSiteStatus, ixModule,awsDashboard, ranNesting_report, ranNesting_tracker, timeZoneApi, manageutilizationApi, pierTTGroupapi, updateUser, mobileDatacoptl, SSVDashboard, SSVDashboardAPI, LSSVDashboardAPI, SevenTwoAlarmFetchSingle,   } from "../../common/config"


import { common, commonPost, commonDelete, commonupdate, commonOne, commonDeleteWithFormData, commondownload } from "../../services/AdminService"
import { MopDatabaseAction } from "./dashboardActions"
import { saveAs } from 'file-saver';
import { ExportToExcel } from "../../common/ExportToExcel"


import { useHistory } from "react-router-dom"
import {CustomRedirect} from "../../common/variables"
// import { useHistory } from 'react-router-dom';


// const history =useHistory()

export function ProjectBucketReducerAction(reqUrl) {
    console.log("function call=")
    return (dispatch, getState) => {
        console.log("req url=", reqUrl)
        common(reqUrl).then((response) => {
            console.log("response=", response.data.data)
            dispatch(getProjectBucketAction(response.data.data))
        })
            .catch((err) => {
                console.log("common err=", err)
            })
    }
}



export function gms_utms(reqUrl) {
    console.log("function call=")
    return (dispatch, getState) => {
        console.log("req url=", reqUrl)
        common(reqUrl).then((response) => {
            dispatch(gms_utmsAction(response.data.data))
        })
            .catch((err) => {
                console.log("common err=", err)
            })
    }
}



export function list_rfds_all(reqUrl) {
    console.log("function call=")
    return (dispatch, getState) => {
        console.log("req url=", reqUrl)
        common(reqUrl).then((response) => {
            console.log("response=", response.data.data)
            dispatch(list_rfdsAction(response.data.data))
        })
            .catch((err) => {
                console.log("common err=", err)
            })
    }
}




export function gms_utmsAction(res) {
    return {
        type: FETECH_GSM_UTMS,
        payload: res,
    };
}

export function list_rfdsAction(res) {
    return {
        type: FETECH_RFDS_LIST,
        payload: res,
    };
}



export function ProjectStatusReducerAction(reqUrl) {
    return (dispatch, getState) => {
        console.log("req url=", reqUrl)
        common(reqUrl).then((response) => {
            console.log("response=", response.data.data)

            dispatch(getProjectStatusAction(response.data.data))

        })
            .catch((err) => {
                console.log("common err=", err)
            })
    }
}

// Manage Market 
export function GetMarketReducerAction(reqUrl) {
    return (dispatch, getState) => {
        console.log("req url=", reqUrl)
        common(reqUrl).then((response) => {
            console.log("response=", response.data.data)
            if (response.data.data) {
                dispatch(getMarketAction(response.data.data))
            }
        })
            .catch((err) => {
                console.log("common err=", err)
            })
    }
}


export function GetFilterUserReducerAction(reqUrl) {
    return (dispatch, getState) => {
        console.log("req url=", reqUrl)
        common(reqUrl).then((response) => {
            console.log("response=", response.data.data)
            if (response.data.data) {
                dispatch(getFilterUserAction(response.data.data))
            }
        })
            .catch((err) => {
                console.log("common err=", err)
            })
    }
}

// Add Market
export function addMarketReducerAction(reqUrl, sendData) {
    return (dispatch, getState) => {
        console.log("nfdegebgtrdhrbdfsg=dg=", sendData)
        commonPost(reqUrl, sendData).then((response) => {
            
            dispatch(popUpUpdate(response))
            console.log("response addMarketReducerAction =", response)
            swal({
                // title: "Good job!",
                text: response.data.msg,
                // icon: "success",
                button: "Ok",
            })
            // dispatch(GetMarketReducerAction(getMarket))
        })
            .catch((err) => {
                console.log("AccountApi error=", err.response)
                swal({
                    // title: "Good job!",
                    text: err.response?err.response.data.msg:"",
                    // icon: "success",
                    button: "Ok",
                })
            })
    }
}
// Delete Market


export function getProjectBucketAction(res) {
    return {
        type: FETECH_BUCKET,
        payload: res
    };
}



export function getFilterUserAction(res) {
    return {
        type: FETECH_FILTER_USER,
        payload: res
    };
}

export function getMarketAction(res) {
    return {
        type: FETECH_MARKETS,
        payload: res
    }
}

export function getProjectStatusAction(res) {
    return {
        type: FETECH_PROJECT_STATUS,
        payload: res
    }
}


export function getUserRoleAction(res) {
    return {
        type: FETECH_USER_ROLE,
        payload: res
    };
}



// export function OneAccountReducerAction(reqUrl){
//     return (dispatch,getState)=>{
//         common(reqUrl).then((response)=>{
//                 console.log("response =",response.data.data)
//                 dispatch(oneGetAccountAction(response.data.data))
//         })
//         .catch((err)=>{
//             console.log("AccountApi error=",err)
//         })
//     }
// }
// export function oneGetAccountAction(res){
//     return {
//         type:ONEFETECH_ACCOUNT,
//         payload:res
//     }
// }


// Account Action section

export function RoleReducerAction(reqUrl) {
    return (dispatch, getState) => {
        common(reqUrl).then((response) => {
            console.log("response =", response.data.data)
            dispatch(getUserRoleAction(response.data.data))
        })
            .catch((err) => {
                console.log("RoleReducerAction=", err)
            })
    }
}




export function getUserListAction(res) {
    return {
        type: FETECH_USER_LIST,
        payload: res
    };
}


export function getTierListAction(res) {
    return {
        type: FETECH_TIER_LIST,
        payload: res
    };
}




// Account Action section

export function UserListReducerAction(reqUrl) {
    return (dispatch, getState) => {
        console.log(reqUrl, "UserListReducerAction")
        common(reqUrl).then((response) => {

            // console.log("UserListReducerAction =", response.data.data)

            dispatch(popUpUpdate(response))
            dispatch(getUserListAction(response.data.data))
        })
            .catch((err) => {
                console.log("RoleReducerAction=", err)
            })
    }
}


export function TierListReducerAction(reqUrl) {
    return (dispatch, getState) => {
        console.log(reqUrl, "UserListReducerAction")
        common(reqUrl).then((response) => {

            // console.log("UserListReducerAction =", response.data.data)

            dispatch(getTierListAction(response.data.data))
        })
            .catch((err) => {
                console.log("RoleReducerAction=", err)
            })
    }
}



export function networkGetCSVReducerAction(reqUrl,typer=false){
    return (dispatch,getState)=>{
        common(reqUrl).then((response)=>{
                console.log("UserListReducerAction =",response.data.data)
                dispatch(CountDatabaseAction(response.data.totalCountDb,"networkDB"))
                if(typer){
                    dispatch(clearnetworkgetCSVListAction(response.data.data))
                    
                }else{
                    dispatch(networkgetCSVListAction(response.data.data))
                }
                // if(reqUrl.includes("?series=")){
                //     console.log("th responsswd")
                //     getState().csvResponse.networkdatabase.push(...response.data.data)
                //     console.log("th responsswd",getState().csvResponse.networkdatabase)
                // }
                // else{ 
                // dispatch(networkgetCSVListAction(response.data.data))
                // }
        })
        .catch((err)=>{
            console.log("RoleReducerAction=",err)
        })
    }
}


export function inflightGetCSVReducerAction(reqUrl){
    return (dispatch,getState)=>{

        common(reqUrl).then((response)=>{
            console.log(response,"responseresponseresponse")

            dispatch(CountDatabaseAction(response.data.totalCountDb,"inflight"))
            dispatch(inflightgetCSVListAction(response.data.data))
            // if(reqUrl.includes("?series=")){
            //     console.log("th responsswd")
            //     getState().csvResponse.inflight.push(...response.data.data)
            //     console.log("th responsswd",getState().csvResponse.inflight)
            // }
            // else{   
            //      console.log("UserListReducerAction =",response.data.data)

            //     dispatch(inflightgetCSVListAction(response.data.data))
            // }
            })
        .catch((err)=>{
            console.log("RoleReducerAction=",err)
        })
    }
}

export function funVendorScoreCardDashboard(res) {
    return {
        type: FUNVENDOR_SCORE_CARD_DASHBOARD,
        payload: res
    }
}

export function funVendorScoreCard(res) {
    return {
        type: FUNVENDOR_SCORE_CARD,
        payload: res
    }
}

export function getBarChartData(res) {
    return {
        type: GETBARCHARTDATA,
        payload: res
    }
}

export function AccountReducerActionWithoutLoad(reqUrl, smart = true, typpe = true) {
    return (dispatch, getState) => {
        // if (smart) {
        //     dispatch(setLoaderAction(true))
        // }
        common(reqUrl).then((response) => {
            if (smart) {
                dispatch(setLoaderAction(false))
            }

            // if(reqUrl == scorecardpiefilters){
            dispatch(setLoaderAction(false))
            if (reqUrl.includes(scorecardpiefilters)) {
                dispatch(getFilterDropDown(response.data.data))
            }


            // if (reqUrl.includes(scorecardpiefilters)) {
            //     dispatch(getFilterDropDown(response.data.data))
            // }
        })
    }

}

export function VendorScoreCardReducerAction(reqUrl, smart = true, typpe = true) {
    return (dispatch, getState) => {
        if (smart) {
            dispatch(setLoaderAction(true))
        }
        common(reqUrl).then((response) => {
            dispatch(setLoaderAction(false))
            if (reqUrl.includes(VendorScoreCardApi)) {
                dispatch(funVendorScoreCard(response.data.data))
            }

            if(reqUrl.includes(VendorScoreCardDashboard)){
                dispatch(funVendorScoreCardDashboard(response.data.data))
            }
        })
    }

}


export function allMapSiteReducerAction(reqUrl){
    return (dispatch,getState)=>{
        common(reqUrl).then((response)=>{
                console.log("UserListReducerAction =",response.data.data)

                dispatch(allMapSites(response.data.data))
        })
        .catch((err)=>{
            console.log("RoleReducerAction=",err)
        })
            .catch((err) => {
                console.log("RoleReducerAction=", err)
            })
    }
}

export function magentaGetCSVReducerAction(reqUrl){
    return (dispatch,getState)=>{
        common(reqUrl).then((response)=>{

            console.log()
            dispatch(CountDatabaseAction(response.data.totalCountDb,"magenta"))
            
            dispatch(magentagetCSVListAction(response.data.data))
            // if(reqUrl.includes("?series=")){
            //     console.log("th responsswd")
            //     getState().csvResponse.magenta.push(...response.data.data)
            //     // console.log("th responsswd",getState().csvResponse.inflight)
            // }
            // else{
            //     console.log("UserListReducerAction =",response.data.data)

            //     dispatch(magentagetCSVListAction(response.data.data))
            // }
            })
        .catch((err)=>{
            console.log("RoleReducerAction=",err)
        })
            .catch((err) => {
                console.log("RoleReducerAction=", err)
            })
    }
}



export function ExportXLSXDownloadReducerAction(reqUrl,fileName,sendData="",bodyData=[]) {
    return (dispatch, getState) => {
        const FileDownload = require('js-file-download');

        console.log("ExportDownloadReducerAction",reqUrl,fileName,sendData)
        dispatch(setLoaderAction(true))
        
        commondownload(reqUrl,"blob",{"dataUrl":sendData,"bodyData":bodyData}).then((response) => {
            dispatch(setLoaderAction(false))
            // FileDownload(response.data,`${fileName}.xlsx`)
            // console.log(response,"ExportDownloadReducerAction")

            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `${fileName}.xlsx`);
            document.body.appendChild(link);
            link.click();
          

            // const href = URL.createObjectURL(response.data);
            // const link = document.createElement('a');
            // link.href = href;
            // link.setAttribute('download', 'file.pdf'); //or any other extension
            // document.body.appendChild(link);
            // link.click();
            // document.body.removeChild(link);
            // URL.revokeObjectURL(href);
            // console.log("ExportDownloadReducerAction",response)
            // saveAs(response.data, fileName)
            // ExportToExcel(response.data,fileName)
        })
    }
}



export function ExportDownloadReducerAction(reqUrl,fileName,ext) {
    return (dispatch, getState) => {
        const FileDownload = require('js-file-download');
        const fs = require('fs');

        console.log("ExportDownloadReducerAction",reqUrl,fileName)
        dispatch(setLoaderAction(true))
        
        commondownload(reqUrl,"stream").then((response) => {
            dispatch(setLoaderAction(false))
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `${fileName}.${ext}`);
            document.body.appendChild(link);
            link.click();
        })
    }
}




export function chat_message_pending_reducer(data) {
    return (dispatch, getState) => {

        console.log(data,"getSiteId")
        dispatch(chat_message_pending(data))
    }
}

export function get_chat_message_pending_reducer(data) {
    return (dispatch, getState) => {
        return getState().OneCommonResponse.ChatInfo.siteId
    }
}

export function AccountReducerAction(reqUrl,smart=true,typpe=true) {
   
    // console.log(reqUrl,reqUrl,ranNesting, "AccountReducerActionreqUrl")
    return (dispatch, getState) => {
        if(smart){
            dispatch(setLoaderAction(true))
        }
        common(reqUrl).then((response) => {
            dispatch(setLoaderAction(false))
            dispatch(popUpUpdate(response))
            console.log("response =", response.data.data)
            if (response.data.data) {
                if(reqUrl==userTableData){
                    dispatch(LCLTTCOLReducerAction(response.data.data.databaseData,"First"))
                    dispatch(LCLTTCOLReducerAction(response.data.data.allCols,"Full Data"))
                }
                if(reqUrl.includes(SSVDashboardAPI)){
                    dispatch(setSSVDashboard(response.data.data))
                }
                if(reqUrl.includes(LSSVDashboardAPI)){
                    dispatch(setLaunchSSVDashboard(response.data.data))
                }
                if(reqUrl ==timeZoneApi){
                    dispatch(getTimeZone(response.data.data))
                }
                if(reqUrl==mopFilters || reqUrl==ranfilters || reqUrl==ttfilters || reqUrl==enoofilters || reqUrl==commonfilters || reqUrl == nwfilters){
                    dispatch(getFilterDropDown(response.data.data))
                }

                if (reqUrl.includes(MOPInstructionApi)) {
                    console.log(response.data.data,"MOPInstructionApi")
                    dispatch(getMOPInstructionAction(response.data.data))
                }
                
                if (reqUrl === "/PAG/account") {
                    dispatch(getAccountAction(response.data.data))
                }
                if (reqUrl === "/PAG/technology") {
                    dispatch(getTechnologyAction(response.data.data))
                }
                if (reqUrl === "/PAG/equipment") {
                    dispatch(getEquipmentAction(response.data.data))
                }
                if (reqUrl === "/PAG/vendor") {
                    dispatch(getVendorAction(response.data.data))
                }
                if (reqUrl === "/PAG/crewCompany") {
                    dispatch(getCrewCompanyAction(response.data.data))
                }

                if (reqUrl.includes("/PAG/manual/requestPreCheck/")) {

                    dispatch(AccountReducerAction(ranDashboard))
                }

                if (reqUrl === "/PAG/oss") {
                    dispatch(getOssAction({ ossData: response.data.data, ossType: response.data.oss_data }))
                }
                if (reqUrl === "/PAG/groupByoss") {
                    dispatch(getOssAction({ ossData: response.data.data }))
                }
                if (reqUrl.includes("/PAG/listTroubleTicket")) {
                    console.log("the dispatch is =", response)
                    // dispatch(GetttProject(response.data.data))
                    dispatch(CountDatabaseAction(response.data.TotalTicket,"List TT"))
                    if(typpe){
                        dispatch(GetclearttProject(response.data.data))
                    }else{
                        dispatch(GetttProject(response.data.data))
                    }
                }
                if (reqUrl.includes("/PAG/listenno")) {
                    console.log("the dispatch is =", response)
                    dispatch(CountDatabaseAction(response.data.TotalTicket,"List ENOO"))
                    if(typpe){
                        dispatch(GetclearennoProject(response.data.data))
                    }else{
                        dispatch(GetennoProject(response.data.data))
                    }

                    
                }

                
                if (reqUrl.includes("/PAG/RanDashboard")) {

                    if(typpe){
                        dispatch(getClearRanDashboard(response.data.data.tableData))
                        
                    }else{
                        dispatch(getRanDashboard(response.data.data.tableData))
                    }
                    // dispatch(getRanDashboard(response.data.data.tableData))
                    dispatch(CountDatabaseAction(response.data.data.TotalTicket,"RAN Dashboard"))
                    if(smart){
                        dispatch(AccountReducerAction(ranSiteStatus));
                    }
                }
                // if(reqUrl==="/PAG/rtt/dashboard"){
                //     dispatch(getRanDashboard(response.date.data.tableData))
                // }

                if(reqUrl.includes("/PAG/rtt/dashboard")){
                    // dispatch(getRanDashboard(response.date.data.tableData))
                    dispatch(CountDatabaseAction(response.data.TotalTicket,"List RTT"))
                    if(typpe){
                        dispatch(GetclearrttProject(response.data.data))
                    }else{
                        dispatch(GetrttProject(response.data.data))
                    }
                }
                    
                if (reqUrl === "/PAG/RanSpilOver") {
                    dispatch(CountDatabaseAction(response.data.data.TotalTicket,"ranSpilOver"))
                    dispatch(getRanSpilOver(response.data.data.tableData))
                }

                // if(reqUrl=="/PAG/72alarm/"){
                //     dispatch(set72Alarm(response.data.data))
                // }
                if(reqUrl.includes("/PAG/72alarm/")){
                    dispatch(set72Alarm(response.data.data))
                    if(typpe){
                        dispatch(GetclearsSTProject(response.data.data))
                    }else{
                        dispatch(GetSTProject(response.data.data))
                    }
                }
                    
                
                if (reqUrl.includes(ranNesting_report)) {
                    dispatch(CountDatabaseAction(response.data.data.TotalTicket,"ranNestingReport"))

                    if(typpe){
                        dispatch(getClearRanNestingReport(response.data.data.tableData)) 
                    }else{
                        dispatch(getRanNestingTracker(response.data.data.tableData))
                    }
                }

                

                if (reqUrl.includes(ranNesting_tracker)) {
                    dispatch(CountDatabaseAction(response.data.data.TotalTicket,"ranNestingTracker"))
                    if(typpe){
                        dispatch(getClearRanNestingTracker(response.data.data.tableData))     
                    }else{
                        dispatch(getRanNestingReport(response.data.data.tableData))
                    }
                }

                if (reqUrl === geoFencing) {
                    dispatch(getGeoFencing(response.data.data))
                }

                if (reqUrl === manageutilizationApi) {
                    dispatch(getmanageutilization(response.data.data))
                }

                

              

                
                if (reqUrl === "/PAG/ran/siteStatus" || reqUrl === ixSiteStatus) {
                    dispatch(getRanSiteStatusData(response.data.data))
                }

                if (reqUrl === pierTTGroupapi) {
                    dispatch(getpierTTGroupData(response.data.data))
                }

                
                if (reqUrl === "/PAG/mop/siteStatus") {
                    dispatch(getMopSiteStatusData(response.data.data))
                }

                
                if (reqUrl === ttDashSiteStatus) {
                    dispatch(getttSiteStatusData(response.data.data))
                }

                
                
                if (reqUrl === "/PAG/grouplistStatus") {
                    if(reqUrl.includes("?series=")){
                        console.log("th responsswd")
                        getState().commonReducer.networkDatabaseSiteStatus.push(...response.data.data)
                        console.log("th responsswd",getState().commonReducer.networkdatabase)
                    }
                   else{
                     console.log("the nt is", response.data.data)
                    dispatch(NetworkDatabaseSiteStatusAction(response.data.data))
                   }
                }
                if (reqUrl === "/PAG/listSite" || reqUrl === "/PAG/sitedblistSite" || reqUrl === "/PAG/ranlistSite") {
                    console.log("the dispatch=,")
                    dispatch(StartAwaitedSiteAction(response.data.data))
                }

                if (reqUrl === "/PAG/crnumber_op") {
                    console.log("the cr numer list is=", response.data.data)
                    dispatch(GETCrNumberAction(response.data.data))
                }
                if (reqUrl.includes("/PAG/RanTracker")) {
                    
                    console.log(response.data,"response.data.TotalTicket")
                    dispatch(CountDatabaseAction(response.data.data.TotalTicket,"ranTracker"))
                    if(typpe){
                        dispatch(clearranTrackerAction(response.data.data))
                    }else{
                        dispatch(ranTrackerAction(response.data.data))
                    }
                }
                if (reqUrl.includes("/PAG/RanSla")){
                    
                    dispatch(CountDatabaseAction(response.data.data.TotalTicket,"ranSla"))
                    if(typpe){
                        dispatch(clearslaranTrackerAction(response.data.data))
                    }else{
                        dispatch(slaranTrackerAction(response.data.data))
                    }
                }
                // if (reqUrl.includes("/PAG/cancel/requestPreCheck/")) {
                //     if(reqUrl.includes("?ix=True")){
                        
                //         dispatch(AccountReducerAction(ixModule))
                //     }
                    
                //     let Filleddata=dispatch(LCLranDashboardReducerAction())
                //     dispatch(AccountReducerAction(ranDashboard+Filleddata,true));
                //     // dispatch(AccountReducerAction(ranDashboard))
                // }
                if (reqUrl.includes("/PAG/manage/dropDownlist")) {
                    dispatch(getAllDropDown(response.data.data))
                }
                if (reqUrl.includes("/PAG/manage/dropDowns")) {
                    if(typpe){
                        dispatch(SingleDropDownAction(response.data.data))
                    }else{
                        dispatch(SingleADropDownAction(response.data.data))
                        
                    }
                }
                
                // if(reqUrl.includes("/PAG/ixDashboard")){
                //     console.log("the ix dashboard=",response.data.data)
                //     dispatch(getIXDashboard(response.data.data))
                // }


                if(reqUrl.includes("/PAG/ixDashboard")){
                    console.log("the ix dashboard=",response.data.data)
                    dispatch(getIXDashboard(response.data.data))
                    if(typpe){
                        dispatch(GetclearsIXProject(response.data.data))
                    }else{
                        dispatch(GetIXProject(response.data.data))
                    }

                    if(smart){
                        dispatch(AccountReducerAction(ixSiteStatus));
                    }
                }
                    
                if(reqUrl==="/PAG/rttDashboard"){
                    console.log("the RTT dashboard=",response)
                    dispatch(getrttDashboard(response.data.data))
                }

                

                if(reqUrl===getAllDropDownList){
                    dispatch(getAllDropDown(response.data.data))
                }


            }
        })
            .catch((err) => {
                dispatch(setLoaderAction(false))
                console.log("AccountReducerAction error=", err)
            })
    }
}




export function LCLranSLAReducerAction(fullURL) {
    return (dispatch, getState) => {
        if(fullURL){
            dispatch(LCLranSLAfilter(fullURL))
        }
        // getState
        // console.log("nfdegebgtrdhrbdfsg=dg=", getState().lclFilterDashboard.ranDashboard)
        let statedta=getState().lclFilterDashboard.ranDashboard
        let filData=commonFilter(statedta)
        console.log(filData,"filDatafilData")
        return filData
    }
}


export function LCLranSLAfilter(res) {
    console.log(res,"LCLmopDashboardfilter")
    return {
        type: LCL_RAN_SLA_FILTER,
        payload: res
    }
}





export function GetclearrttProject(res) {
    return {
        type: FETECH_NEW_RTT_PROJECT,
        payload: res
        
        
        }
    }
    
    
export function GetrttProject(res) {
    return {
        type: FETECH_RTT_PROJECT,
        payload: res
        
    
    }
    }
    
    
    
    
export function GetclearsSTProject(res) {
        return {
            type: FETECH_NEW_ST_PROJECT,
            payload: res
            }
    }
    
    
export function GetSTProject(res) {
    return {
        type: FETECH_ST_PROJECT,
        payload: res
    }
}
    
    
    
    
    
    
    
    
export function GetclearsIXProject(res) {
    return {
        type: FETECH_NEW_IX_PROJECT,
        payload: res
    }
}
    
    
export function GetIXProject(res) {
    return {
        type: FETECH_IX_PROJECT,
        payload: res
    }
}
    
    
    
    
    

function getProjectId(res) {
    return {
        type: FETECH_PRODUCT_ID,
        payload: res
    }
}

export function clearProjectId() {

    console.log("clearProjectId amit_logger")
    return {
        type: FETECH_PRODUCT_ID,
        payload: []
    }
}
// use for future export function clearOneNwDb() {
//     return {
//         type: FETECH_SINGLE_PROJECTDATABASE,
//         payload: []
//     }
// }

// function getIxDashboardData(res){
//     return{
//         type:
//     }
// }

function allMapSites(res){
    return {
        type:GET_ALL_MAP_SITES,
        payload:res
    }
}

function getTimeZone(res){
    return {type:TIME_ZONE,
    payload:res
    }
}

function magentagetCSVListAction(res){
    return {
        type:MAGENTA_FETECH_CSV_DATA,
        payload:res
    }
}


function inflightgetCSVListAction(res){
    return {
        type:INFLIGHT_FETECH_CSV_DATA,
        payload:res
    }
}


function networkgetCSVListAction(res){
    return {
        type:NETWORK_DATABASE_FETECH_CSV_DATA,
        payload:res
    }
}
function clearnetworkgetCSVListAction(res){
    return {
        type:CLEAR_NETWORK_DATABASE_FETECH_CSV_DATA,
        payload:res
    }
}

function FetechProductCode(res) {

    
    return {
        type: FETECH_PRODUCT_CODE,
        payload: res
    }
}

export function ClearProductCode() {

    
    console.log("ClearProductCode amit_logger")
    return {
        type: FETECH_PRODUCT_CODE,
        payload: []
    }
}
export function set72Alarm(res){
    return{
        type :FETECH_72_Alarm,
        payload:res
    }
}
export function FetechSingleMops(res) {
    console.log(res)
    return {
        type: FETECH_SINGLE_MOPS,
        payload: res
    }
}
function FetechNesting(res) {
    console.log(res)
    return {
        type: FETECH_NESTING_TIMELINE,
        payload: res
    }
}

function singlemobileDatacoptl(res) {
    console.log(res)
    return {
        type: FETECH_MOBILE_DATA_COP_TIMELINE,
        payload: res
    }
}


export function SingleDropDownAction(res) {
    return {
        type: FETECH_SINGLE_DROPDOWN,
        payload: res
    }
}


export function SingleADropDownAction(res) {
    return {
        type: FETECH_SINGLE_A_DROPDOWN,
        payload: res
    }
}

export function getAllDropDown(res) {
    return {
        type: FETECH_ALL_DROP_DOWN,
        payload: res
    }
}

function GETCrNumberAction(res) {
    return {
        type: FETECH_CR_NUMBER,
        payload: res
    }
}

function StartAwaitedSiteAction(res) {
    return {
        type: FETECH_SITEID,
        payload: res

    }
}
function NetworkDatabaseSiteStatusAction(res) {
    return {
        type: FETECH_NETWORK_SITE_STATUS,
        payload: res
    }
}

export function getMopSiteStatusData(res) {
    return {
        type: FETECH_MOP_STATUS,
        payload: res
    }
}

export function getttSiteStatusData(res) {
    return {
        type: FETECH_TT_STATUS,
        payload: res
    }
}

export function getRanSiteStatusData(res) {
    return {
        type: FETECH_RAN_STATUS,
        payload: res
    }
}
export function getpierTTGroupData(res) {
    return {
        type: FETECH_PIER_TT_GROUP,
        payload: res
    }
}



export function getOssAction(res) {
    return {
        type: FETECH_OSS,
        payload: res,
    }
}


export function ranTrackerAction(res) {
    return {
        type: FETECH_RAN_TRACKER,
        payload: res
    }
}

export function clearranTrackerAction(res) {
    return {
        type: FETECH_CLEAR_RAN_TRACKER,
        payload: res
    }
}


export function slaranTrackerAction(res) {
    return {
        type: FETECH_SLA_RAN_TRACKER,
        payload: res
    }
}

export function clearslaranTrackerAction(res) {
    return {
        type: FETECH_CLEAR_SLA_RAN_TRACKER,
        payload: res
    }
}

export function cleardailyranTrackerAction(res) {
    return {
        type: FETECH_CLEAR_SLA_RAN_TRACKER,
        payload: res
    }
}





export function getrttDashboard(res) {
    return {
        type: FETECH_RTT_DASHBOARD,
        payload: res
    }
}
export function getIXDashboard(res) {
    return {
        type: FETECH_IX_DASHBOARD,
        payload: res
    }
}



export function clearIxDashboard(){

    console.log("clear Ourself")
    return {
        type:FETECH_IX_DASHBOARD,
        payload:[]
    }
}

export function getRanDashboard(res) {
    return {
        type: FETECH_RAN_DASHBOARD,
        payload: res
    }
}

export function getClearRanDashboard(res) {
    return {
        type: FETECH_CLEAR_RAN_DASHBOARD,
        payload: res
    }
}

export function CountDatabaseAction(res,name){
    return {
        type: FETECH_COUNT_DATA,
        payload: [res,name],
    };
}

export function getRanSpilOver(res) {
    return {
        type: FETECH_RAN_SPILOVER,
        payload: res
    }
}
export function getRanNestingReport(res) {
    return {
        type: FETECH_RAN_NESTING_REPORT,
        payload: res
    }
}
export function getRanNestingTracker(res) {
    return {
        type: FETECH_RAN_NESTING_TRACKER,
        payload: res
    }
}


export function getClearRanNestingReport(res) {
    return {
        type: FETECH_CLEAR_RAN_NESTING_REPORT,
        payload: res
    }
}
export function getClearRanNestingTracker(res) {
    return {
        type: FETECH_CLEAR_RAN_NESTING_TRACKER,
        payload: res
    }
}

export function getGeoFencing(res) {
    return {
        type: FETECH_GEO_FENCING,
        payload: res
    }
}

export function chat_message_pending(res) {
    return {
        type: CHAT_MESSAGE_PENDING,
        payload: res
    }
}





export function getmanageutilization(res) {
    return {
        type: FETECH_MANAGE_UTILIZATION,
        payload: res
    }
}

export function getTechnologyAction(res) {
    return {
        type: FETECH_TECHNOLOGY,
        payload: res
    }
}


export function getVendorAction(res) {
    return {
        type: FETECH_VENDOR,
        payload: res
    }
}

export function getCrewCompanyAction(res) {
    return {
        type: FETECH_CREW_COMPANY,
        payload: res
    }
}
export function getEquipmentAction(res) {
    return {
        type: FETECH_EQUIPMENT,
        payload: res
    }
}


export function popUpUpdate(res) {

    console.log(res,"popUpUpdate")
    return {
        type: UPDATE_POP_UP,
        payload: res
    }
}


function commonFilter(statedta){
    let merge_data=""
    let adata=[]
    for (let key in statedta) {
        console.log("nfdegebgtrdhrbdfsg=dg=", statedta[key])
        if (statedta[key] !== "") {
            adata.push(statedta[key])
            // merge_data += "&"+statedta[key];
        }
    }
    console.log("nfdegebgtrdhrbdfsg=dg=", merge_data, adata.join("&"))
    return adata.length>0?"?"+adata.join("&"):""
}


export function LCLranDashboardReducerAction(fullURL) {
    return (dispatch, getState) => {
        if(fullURL){
            dispatch(LCLranDashboardfilter(fullURL))
        }
        // getState    
        // console.log("nfdegebgtrdhrbdfsg=dg=", getState().lclFilterDashboard.ranDashboard)
        let statedta=getState().lclFilterDashboard.ranDashboard
        let filData=commonFilter(statedta)
        console.log(filData,"filDatafilData")
        return filData
    }
}


export function LCLranSlaReducerAction(fullURL) {
    return (dispatch, getState) => {
        if(fullURL){
            dispatch(LCLslaDashboardfilter(fullURL))
        }
        // getState    
        // console.log("nfdegebgtrdhrbdfsg=dg=", getState().lclFilterDashboard.ranDashboard)
        let statedta=getState().lclFilterDashboard.slaDashboard
        let filData=commonFilter(statedta)
        console.log(filData,"filDatafilData")
        return filData
    }
}





export function LCLssvDashboardReducerAction(fullURL) {
    return (dispatch, getState) => {
        if(fullURL){
            dispatch(LCLssvDashboardfilter(fullURL))
        }
        // getState    
        // console.log("nfdegebgtrdhrbdfsg=dg=", getState().lclFilterDashboard.ranDashboard)
        let statedta=getState().lclFilterDashboard.ssvDashboard
        let filData=commonFilter(statedta)
        console.log(filData,"filDatafilData")
        return filData
    }
}

export function LCLlssvDashboardReducerAction(fullURL) {
    return (dispatch, getState) => {
        if(fullURL){
            dispatch(LCLlssvDashboardfilter(fullURL))
        }
        // getState    
        // console.log("nfdegebgtrdhrbdfsg=dg=", getState().lclFilterDashboard.ranDashboard)
        let statedta=getState().lclFilterDashboard.lssvDashboard
        let filData=commonFilter(statedta)
        console.log(filData,"filDatafilData")
        return filData
    }
}


export function LCLixDashboardReducerAction(fullURL) {
    return (dispatch, getState) => {
        if(fullURL){
            dispatch(LCLixDashboardfilter(fullURL))
        }
        // getState    
        // console.log("nfdegebgtrdhrbdfsg=dg=", getState().lclFilterDashboard.ranDashboard)
        let statedta=getState().lclFilterDashboard.ixDashboard
        let filData=commonFilter(statedta)
        console.log(filData,"filDatafilData")
        return filData
    }
}


export function ResetslaDashboardReducerAction() {
    return (dispatch, getState) => {
        // alert("ResetLCLmopDashboardReducerAction")
        console.log("reseting the data")
        dispatch(ResetSLADashboardfilter())
        let statedta=getState().lclFilterDashboard.slaDashboard
        let filData=commonFilter(statedta)
        console.log(filData,"filDatafilData")
        return filData
        
    }
}

export function ResetixDashboardReducerAction() {
    return (dispatch, getState) => {
        // alert("ResetLCLmopDashboardReducerAction")
        console.log("reseting the data")
        dispatch(ResetLCLixDashboardfilter())
        let statedta=getState().lclFilterDashboard.ixDashboard
        let filData=commonFilter(statedta)
        console.log(filData,"filDatafilData")
        return filData
        
    }
}


export function ResetLCLranDashboardReducerAction() {
    return (dispatch, getState) => {
        // alert("ResetLCLmopDashboardReducerAction")
        console.log("reseting the data")
        dispatch(ResetLCLranDashboardfilter())
        let statedta=getState().lclFilterDashboard.ranDashboard
        let filData=commonFilter(statedta)
        console.log(filData,"filDatafilData")
        return filData
        
    }
}





export function LCLNestingReducerAction(fullURL) {
    return (dispatch, getState) => {
        if(fullURL){
            dispatch(LCLNestingfilter(fullURL))
        }
        let statedta=getState().lclFilterDashboard.enoo
        let filData=commonFilter(statedta)
        console.log(filData,"filDatafilData")
        return filData
    }
}




export function ResetLCLNestingReducerAction() {
    return (dispatch, getState) => {
        // alert("ResetLCLmopDashboardReducerAction")
        console.log("reseting the data")
        dispatch(ResetLCLNestingfilter())
        let statedta=getState().lclFilterDashboard.enoo
        let filData=commonFilter(statedta)
        console.log(filData,"filDatafilData")
        return filData
        
    }
}


export function LCLENOOReducerAction(fullURL) {
    return (dispatch, getState) => {
        if(fullURL){
            dispatch(LCLENOOfilter(fullURL))
        }
        let statedta=getState().lclFilterDashboard.enoo
        let filData=commonFilter(statedta)
        console.log(filData,"filDatafilData")
        return filData
    }
}




export function ResetLCLENOOReducerAction() {
    return (dispatch, getState) => {
        // alert("ResetLCLmopDashboardReducerAction")
        console.log("reseting the data")
        dispatch(ResetLCLENOOfilter())
        let statedta=getState().lclFilterDashboard.enoo
        let filData=commonFilter(statedta)
        console.log(filData,"filDatafilData")
        return filData
        
    }
}


export function ResetLCLLSSVReducerAction() {
    return (dispatch, getState) => {
        // alert("ResetLCLmopDashboardReducerAction")
        console.log("reseting the data")
        dispatch(ResetlssvDashboardfilter())
        let statedta=getState().lclFilterDashboard.lssvDashboard
        let filData=commonFilter(statedta)
        console.log(filData,"filDatafilData")
        return filData
        
    }
}

export function ResetLCLSSVReducerAction() {
    return (dispatch, getState) => {
        // alert("ResetLCLmopDashboardReducerAction")
        console.log("reseting the data")
        dispatch(ResetssvDashboardfilter())
        let statedta=getState().lclFilterDashboard.ssvDashboard
        let filData=commonFilter(statedta)
        console.log(filData,"filDatafilData")
        return filData
        
    }
}


export function LCLTTReducerAction(fullURL) {
    return (dispatch, getState) => {
        if(fullURL){
            dispatch(LCLTTfilter(fullURL))
        }
        let statedta=getState().lclFilterDashboard.tt
        let filData=commonFilter(statedta)
        console.log(filData,"filDatafilData")
        return filData
    }
}


export function LCLBodyReducerAction() {
    return (dispatch, getState) => {
        let statedta=getState().lclFilterDashboard.ttexport
        console.log(statedta,"filDatafilData")
        return statedta
    }
}

export function LCLTTCOLReducerAction(cols,type) {
    return (dispatch, getState) => {

        console.log(cols,type,"LCLTTCOLReducerAction")

        
        dispatch(LCLEXPORTTTfilter(cols,type))

        
        // if(fullURL){
        //     dispatch(LCLTTfilter(fullURL))
        // }
        // let statedta=getState().lclFilterDashboard.tt
        // let filData=commonFilter(statedta)
        // console.log(filData,"filDatafilData")
        // return filData
    }
}




export function ResetLCLTTReducerAction() {
    return (dispatch, getState) => {
        // alert("ResetLCLmopDashboardReducerAction")
        console.log("reseting the data")
        dispatch(ResetLCLTTfilter())
        let statedta=getState().lclFilterDashboard.tt
        let filData=commonFilter(statedta)
        console.log(filData,"filDatafilData")
        return filData
        
    }
}

export function LCLmopDashboardReducerAction(fullURL) {
    return (dispatch, getState) => {
        let adata=[]
        if(fullURL){
            dispatch(LCLmopDashboardfilter(fullURL))
        }
        // getState    
        console.log("nfdegebgtrdhrbdfsg=dg=", getState().lclFilterDashboard.mopDashboard)
        let statedta=getState().lclFilterDashboard.mopDashboard
        let merge_data=""
        for (let key in statedta) {
            
            console.log("nfdegebgtrdhrbdfsg=dg=", statedta[key])
            if (statedta[key] !== "") {
                adata.push(statedta[key])
                // merge_data += "&"+statedta[key];
            }
          }

          console.log("nfdegebgtrdhrbdfsg=dg=", merge_data, adata.join("&"))
        
        
        return adata.length>0?"?"+adata.join("&"):""
    }
}




export function ResetLCLmopDashboardReducerAction() {
    return (dispatch, getState) => {
        // alert("ResetLCLmopDashboardReducerAction")
        console.log("reseting the data")
        dispatch(ResetLCLmopDashboardfilter())
        let adata=[]
        let statedta=getState().lclFilterDashboard.mopDashboard
        let merge_data=""
        for (let key in statedta) {
            console.log("nfdegebgtrdhrbdfsg=dg=", statedta[key])
            if (statedta[key] !== "") {
                adata.push(statedta[key])
            }
          }
        console.log("nfdegebgtrdhrbdfsg=dg=", merge_data, adata.join("&"))
        return adata.length>0?"?"+adata.join("&"):""
    }
}


export function GetLCLmopDashboardReducerAction() {
    return (dispatch, getState) => {
        let statedta=getState().lclFilterDashboard.mopDashboard
        return statedta
    }
}

export function LCLranDashboardfilter(res) {

    console.log(res,"LCLmopDashboardfilter")
    return {
        type: LCL_RAN_DASHBOARD_FILTER,
        payload: res
    }
}


export function LCLslaDashboardfilter(res) {

    console.log(res,"LCLmopDashboardfilter")
    return {
        type: LCL_SLA_DASHBOARD_FILTER,
        payload: res
    }
}

export function LCLssvDashboardfilter(res) {

    console.log(res,"LCLssvDashboardfilter")
    return {
        type: LCL_SSV_FILTER,
        payload: res
    }
}

export function LCLlssvDashboardfilter(res) {

    console.log(res,"LCLlssvDashboardfilter")
    return {
        type: LCL_LSSV_FILTER,
        payload: res
    }
}

export function ResetlssvDashboardfilter() {
    console.log("reseting the data of ResetlssvranDashboardfilter")
    // alert("ResetLCLmopDashboardfilter")
    return {
        type: RESET_LCL_LSSV_FILTER,
        payload: {}
    }
}

export function ResetSLADashboardfilter() {
    console.log("reseting the data of ResetlssvranDashboardfilter")
    // alert("ResetLCLmopDashboardfilter")
    return {
        type: RESET_LCL_SLA_DASHBOARD_FILTER,
        payload: {}
    }
}


export function ResetssvDashboardfilter() {
    console.log("reseting the data of ResetssvranDashboardfilter")
    // alert("ResetLCLmopDashboardfilter")
    return {
        type: RESET_LCL_SSV_FILTER,
        payload: {}
    }
}


export function LCLixDashboardfilter(res) {

    console.log(res,"LCLixDashboardfilter")
    return {
        type: LCL_IX_DASHBOARD_FILTER,
        payload: res
    }
}

export function ResetLCLixDashboardfilter() {
    console.log("reseting the data")
    // alert("ResetLCLmopDashboardfilter")
    return {
        type: RESET_LCL_IX_DASHBOARD_FILTER,
        payload: {}
    }
}


export function ResetLCLranDashboardfilter() {
    console.log("reseting the data")
    // alert("ResetLCLmopDashboardfilter")
    return {
        type: RESET_LCL_RAN_DASHBOARD_FILTER,
        payload: {}
    }
}



export function LCLENOOfilter(res) {

    console.log(res,"LCLmopDashboardfilter")
    return {
        type: LCL_ENOO_FILTER,
        payload: res
    }
}

export function ResetLCLENOOfilter() {
    console.log("reseting the data")
    // alert("ResetLCLmopDashboardfilter")
    return {
        type: RESET_LCL_ENOO_FILTER,
        payload: {}
    }
}


export function LCLNestingfilter(res) {

    console.log(res,"LCLmopDashboardfilter")
    return {
        type: LCL_NESTING_FILTER,
        payload: res
    }
}

export function ResetLCLNestingfilter() {
    console.log("reseting the data")
    // alert("ResetLCLmopDashboardfilter")
    return {
        type: RESET_LCL_NESTING_FILTER,
        payload: {}
    }
}


export function LCLTTfilter(res) {

    console.log(res,"LCLmopDashboardfilter")
    return {
        type: LCL_TT_FILTER,
        payload: res
    }
}


export function LCLEXPORTTTfilter(res,type) {

    console.log(res,"LCLmopDashboardfilter")
    return {
        type: LCL_LEXPORT_TT_FILTER,
        payload: [res,type]
    }
}

export function ResetLCLTTfilter() {
    console.log("reseting the data")
    // alert("ResetLCLmopDashboardfilter")
    return {
        type: RESET_LCL_TT_FILTER,
        payload: {}
    }
}

export function LCLmopDashboardfilter(res) {

    console.log(res,"LCLmopDashboardfilter")
    return {
        type: LCL_MOP_DASHBOARD_FILTER,
        payload: res
    }
}

export function ResetLCLmopDashboardfilter() {
    console.log("reseting the data")
    // alert("ResetLCLmopDashboardfilter")
    return {
        type: RESET_LCL_MOP_DASHBOARD_FILTER,
        payload: {}
    }
}



export function getAccountAction(res) {
    return {
        type: FETECH_ACCOUNT,
        payload: res
    }
}


export function getMOPInstructionAction(res) {
    return {
        type: FETECH_MOP_Instruction,
        payload: res
    }
}

export function getFilterDropDown(res){
    return {
        type: FILTERDROPDOWN ,
        payload: res
    }
}



export function OneUserReducerAction(reqUrl) {
    console.log(reqUrl)
    return (dispatch, getState) => {
        common(reqUrl).then((response) => {
            console.log("response =", response.data.data)
            dispatch(GetOneUserAction(response.data.data))
        })
            .catch((err) => {
                console.log("OneUserReducerAction error=", err)
            })
    }
}


export function OneTierReducerAction(reqUrl) {
    console.log(reqUrl)
    return (dispatch, getState) => {
        common(reqUrl).then((response) => {
            console.log("response =", response.data.data)
            dispatch(GetOneTierAction(response.data.data))
        })
            .catch((err) => {
                console.log("OneUserReducerAction error=", err)
            })
    }
}



export function GetOneUserAction(res) {
    return {
        type: ONE_USER_ACCOUNT,
        payload: res
    }
}


export function GetOneTierAction(res) {
    return {
        type: ONE_USER_ACCOUNT,
        payload: res
    }
}

// Add Account 
export function addAcccountReducerAction(reqUrl, sendData) {
    return (dispatch, getState) => {
        console.log("nfdegebgtrdhrbdfsg=dg=","setLoaderAction true", sendData)
        dispatch(setLoaderAction(true))
        commonPost(reqUrl, sendData).then((response) => {
            
            console.log(reqUrl, "reqUrl")
            console.log("logger response =","setLoaderAction false", response.data.msg)
            dispatch(setLoaderAction(false))
            swal({
                // title: "Good job!",
                text: response.data.msg,
                // icon: "success",
                button: "Ok",
            })
            if(reqUrl.includes("/PAG/ixDashboard")){
                console.log("the ix dashboard=",response.data.data)
                dispatch(getIXDashboard(response.data.data))
            }
            
           if(reqUrl==timeZoneApi){
            dispatch(AccountReducerAction(timeZoneApi))
           }

            if(reqUrl==userTableData){
                dispatch(LCLTTCOLReducerAction(response.data.data.databaseData,"First"))
                dispatch(LCLTTCOLReducerAction(response.data.data.allCols,"Full Data"))
            }

            //   if(reqUrl.contains(updateGCpagdata)||reqUrl.contains(updatedevelopment)||reqUrl.contains(updatefops)||reqUrl.contains(updaterfengineer)){
            //     history.push("/PAG/network/database")
            //   }



            // dispatch(AccountReducerAction(accountApi))
            // dispatch(MopDatabaseAction(mopDataApi))

            if(reqUrl.includes(addFDatatoran)){
                
                let Filleddata=dispatch(LCLranDashboardReducerAction())
                dispatch(AccountReducerAction(ranDashboard+Filleddata,true));
            }

            if(reqUrl.includes(rfApprovalActionChange) || reqUrl.includes(goNoGoAction) || reqUrl.includes(bulkUpload)){
                let Filleddata=dispatch(LCLmopDashboardReducerAction())
                dispatch(MopDatabaseAction(mopDataApi+Filleddata))
            }

            
            dispatch(popUpUpdate(response))
        })
            .catch((err) => {
                dispatch(setLoaderAction(false))
                swal({
                    // title: "Good job!",
                    text: err.response?err.response.data.msg:"",
                    // icon: "success",
                    button: "Ok",
                })
                console.log("addAcccountReducerAction error=", err)
            })
    }
}

export function addCommentReducerAction(reqUrl, sendData) {
    return (dispatch, getState) => {
        console.log("nfdegebgtrdhrbdfsg=dg=","setLoaderAction true", sendData)
        dispatch(setLoaderAction(true))
        commonPost(reqUrl, sendData).then((response) => {
            console.log(reqUrl, "reqUrl")
            console.log("logger response =","setLoaderAction false", response.data.msg)
            dispatch(setLoaderAction(false))
            swal({
                // title: "Good job!",
                text: "Data Updated Successfully",
                // icon: "success",
                button: "Ok",
            })
            
            dispatch(popUpUpdate(response))
        })
            .catch((err) => {
                dispatch(setLoaderAction(false))
                console.log("addAcccountReducerAction error=", err)
            })
    }
}
//Edit Account


export function updateAcccountReducerAction(reqUrl, id, sendData, valer = undefined) {
    return (dispatch, getState) => {
        dispatch(popUpUpdate({}))
        
        dispatch(setLoaderAction(true))
        console.log("nfdegebgtrdhrbdfsg=dg=", getState)
        console.log("nfdeg", id)
        var data=commonupdate(reqUrl, id, sendData).then((response) => {
            dispatch(setLoaderAction(false))
            console.log("response =", reqUrl === "/updateUser")
            swal({
                // title: "Good job!",
                text: response.data.msg,
                // icon: "success",
                button: "Ok",
            })

            
            dispatch(popUpUpdate(response))

            // popUpUpdate(response)

            if (reqUrl === "/PAG/account") {
                dispatch(AccountReducerAction(accountApi))
            }
            if (reqUrl === "/PAG/market") {
                dispatch(GetMarketReducerAction(getMarket))
            }
            // if (reqUrl === "/updateUser") {
            //     dispatch(UserListReducerAction(listUserApi))
            // }
            if (reqUrl === "/PAG/oss") {
                dispatch(AccountReducerAction(ossApi))
            }
            if (reqUrl === allTechnologyApi) {
                dispatch(AccountReducerAction(allTechnologyApi))
            }
            if (reqUrl === addCrewCompany) {
                dispatch(AccountReducerAction(addCrewCompany))
            }
            // if(reqUrl==updateUser){
            //     dispatch(UserListReducerAction(listUserApi_two))
            // }
            
            
            // console.log(valer === "role", 'valer==="role"')
            // if (valer === "tmobile") {
            //     dispatch(UserListReducerAction(listTmobileUserApi))
            // }
            // if (valer === "crew") {
            //     dispatch(UserListReducerAction(listUserApi_two))
            // }
            return "hello"
        })
            .catch((err) => {
                console.log("AccountApi error=", err)
            })
    }
    
}

export function deleteDataUsingFormData(reqUrl, sendData) {
    return (dispatch, getState) => {
        commonDeleteWithFormData(reqUrl, sendData)
            .then((response) => {
                swal({
                    title: "Process completed",
                    text: "Records deleted",
                    icon: "success",
                    button: "Ok",
                })
                dispatch(MopDatabaseAction(mopDataApi))
            })
            .catch((err) => {
                console.log(err)
                swal({
                    title: "Oops",
                    text: "Something went wrong",
                    icon: "warning",
                    button: "Ok",
                })
            })
    }
}

export function deleteAcccountReducerAction(reqUrl, sendData, valer = undefined) {
    return (dispatch, getState) => {
        console.log("deleteAcccountReducerAction=dg=", sendData, valer === "crew")
        commonDelete(reqUrl, sendData).then((response) => {
            console.log("response =", response.data.data,reqUrl)

            dispatch(popUpUpdate(response))
            swal({
                title: "Process completed",
                text: "Records deleted",
                icon: "success",
                button: "Ok",
            })
            if (reqUrl === "/PAG/account") {
                dispatch(AccountReducerAction(accountApi))
            }
            if (reqUrl === "/PAG/market") {
                dispatch(GetMarketReducerAction(getMarket))
            }
            // if (reqUrl === "/deleteUser") {
            //     dispatch(UserListReducerAction(listUserApi))
            // }
            if (reqUrl === "/PAG/oss") {
                dispatch(AccountReducerAction(ossApi))
            }
            if (reqUrl === allTechnologyApi) {
                dispatch(AccountReducerAction(allTechnologyApi))
            }
            if(reqUrl===ranDeleteData){
                dispatch(AccountReducerAction(ranDashboard))
            }
            // if (valer === "role") {
            //     dispatch(UserListReducerAction(listUserApi))
            // }
            if (reqUrl === vendorApi) {
                dispatch(AccountReducerAction(vendorApi))
            }
            // if(reqUrl == "/deleteUser"){
            //     dispatch(UserListReducerAction(listUserApi_two))
            // }

            if(reqUrl.includes("PAG/manage/dropDownlist")){
                // dispatch(SingleDropDownAction(response.data.data))
                dispatch(AccountReducerAction("/PAG/manage/dropDowns/"+valer))
            }

            
        })
        // .catch((err)=>{
        //     console.log("deleteAcccountReducerAction error=",err)
        // })
    }
}

const CustomRedirectFun=({url})=>{
    const history =useHistory()
    history.push(url)
    return <></>
  }
export function addUserAction(reqUrl, sendData, valer = undefined) {
    
     return (dispatch, getState) => {
        
        dispatch(setLoaderAction(true))
        console.log("upload addUserAction in action =", sendData)
        commonPost(reqUrl, sendData).then((response) => {
            console.log("addUserAction response=", response)
            
            dispatch(setLoaderAction(false))
            dispatch(popUpUpdate(response))
            if(reqUrl.includes("?ix=True")){
                dispatch(AccountReducerAction(ixModule));
            }
            else if(reqUrl.includes(changeButtonStatus)){

                        
                let Filleddata=dispatch(LCLranDashboardReducerAction())
                dispatch(AccountReducerAction(ranDashboard+Filleddata,true));
                // dispatch(AccountReducerAction(ranDashboard));
            }
            else if(reqUrl.includes(ixModule)){
                // <CustomRedirectFun url={"/PAG/ix/calender"} />
                dispatch(popUpUpdate(response))
            }
            

            
            if (reqUrl === "/PAG/crnumber") {
                if (response.status === 200) {
                    console.log("response =", response)
                    if (response.data.data[0].ran_status === "Login Awaited - CR Pending") {
                        swal({
                            title: "Cr number is not approved",
                            // text: response.data.msg,
                            icon: "warning",
                            button: "Ok",
                        })
                        
                    }
                    else if (response.data.data[0].ran_status === "Login Awaited - CR Approved") {
                        swal({
                            title: "Valid Cr number",
                            // text: response.data.msg,
                            icon: "success",
                            button: "Ok",
                        })
                    }
                }
                else if (response.status === 204) {
                    swal({
                        title: "This is not valid cr number",
                        // text: response.data.msg,
                        icon: "error",
                        button: "Ok",
                    })
                }
            }
            else {
                console.log("popUpUpdate",response)
                swal({
                    title: "Data add successfully",
                    text: response.data.msg,
                    icon: "success",
                    button: "Ok",
                })
                dispatch(popUpUpdate(response))
                if (reqUrl == "/PAG/account") {
                    dispatch(AccountReducerAction(accountApi))
                }
                if (reqUrl === "/PAG/market") {
                    dispatch(GetMarketReducerAction(getMarket))
                }
                // if(reqUrl=="/addUser"){
                //     dispatch(UserListReducerAction(listUserApi_two))
                // }
                // if (valer === "role") {
                //     dispatch(UserListReducerAction(listUserApi))
                // }
                // if (valer === "crew") {
                //     dispatch(UserListReducerAction(listUserApi_two))
                // }
                // if (valer === "tmobile") {
                //     dispatch(UserListReducerAction(listTmobileUserApi))
                // }
                if (reqUrl === "/PAG/oss") {
                    dispatch(AccountReducerAction(ossApi))
                }
                if (reqUrl === allTechnologyApi) {
                    dispatch(AccountReducerAction(allTechnologyApi))
                }

                                    
                if (reqUrl.includes("/PAG/crnumber_op/")) {

                    console.log("the manage cr number=")
                    dispatch(AccountReducerAction(crNumberList))
                    dispatch(AccountReducerAction(ranDashboard));
                }
            }
        })
        .catch((err) => {
                dispatch(setLoaderAction(false))
                dispatch(popUpUpdate(err.response))
                console.log("site upload error=", err.response)
                // swal({
                //     title: "Oops",
                //     text: err.response?err.response.data.msg:"",
                //     icon: "error",
                //     button: "Ok",
                // })
            })
    }
}


export function clearclearProjectIddAction() {
    console.log("clearFetchSingleRecordAction","amit_logger")
    return (dispatch, getState) => {
        dispatch(clearProjectId())
    }
}


export function clearMopDashboard(){
    return (dispatch, getState) => {
        // dispatch(clearProjectId())
        dispatch(FetechSingleMops([]))
    }
}

export function clearFetchSingleRecordAction() {
    console.log("clearFetchSingleRecordAction","amit_logger")
    return (dispatch, getState) => {
        dispatch(getMOPInstructionAction([]))
        dispatch(clearGetSingleProject())
        dispatch(ClearProductCode())
        dispatch(clearProjectId())
        dispatch(clearGetSingleRanProject())
        dispatch(GetRanTechSingleProject([]))
        dispatch(GetRanSingleProject([]))
        dispatch(clearIxSingleSite([]))
        
    }
}

//Fetech single Records
export function FetchSingleRecordAction(reqUrl, id, type="") {
    return (dispatch, getState) => {

        if(reqUrl === "/PAG/RanDashboard"){
            dispatch(setLoaderAction(true))
        }
        commonOne(reqUrl, id+type ).then((response) => {
            
            dispatch(popUpUpdate(response))
            console.log("the response is =", reqUrl === "/PAG/OneSiteDatabase", reqUrl,response)
            // console.log("response of single project =",response.data.data.tableData[0])
            // swal({
            //     title: "Good job!",
            //     text: "Account Added Successfully",
            //     icon: "success",
            //     button: "Ok",
            //   })
            //   dispatch(AccountReducerAction(accountApi))
            dispatch(setLoaderAction(false))
            if (reqUrl === "/PAG/OneSiteDatabase") {
                console.log("inside dispatch",response.data.data.tableData[0])
                dispatch(GetSingleProject(response.data.data.tableData[0]))
            }
            if (reqUrl === "/PAG/OneNetworkDatabase") {
                console.log("inside dispatch")
                dispatch(GetSingleProjectDatabase(response.data.data.tableData))
                // if(response.data.data.tableData.length<2){
                //     dispatch(GetSingleProjectDatabase(response.data.data.tableData[0]))
                // }
                // else{
                //     dispatch(GetRanSingleProject(response.data.data.tableData))
                //     }
            }
            if(reqUrl==SevenTwoAlarmFetchSingle){
                // dispatch(GetIXSingleProject([]))
                
                dispatch(GetIXSingleProject(response.data.data[0]))
            }
            if(reqUrl=="/PAG/ixDashboard"){
                if(id){
                    console.log("klsdjkfnf=",response)
                    dispatch(GetIXSingleProject(response.data.data.tableData[0]))
                }
                else{
                    dispatch(GetIXSingleProject(response.data.data))
                }
            }
            if(reqUrl=="/PAG/ssvDashboard"){
                if(id){
                    console.log("klsdjkfnf=",response)
                    dispatch(GetIXSingleProject(response.data.data[0]))
                }
            }
            if(reqUrl=="/PAG/rttDashboard/add"){
                if(id){
                    console.log("klsdjkfnf=",response)
                    dispatch(GetIXSingleProject(response.data.data[0]))
                }
            }
            if(reqUrl==LSSVDashboardAPI){
                dispatch(GetIXSingleProject(response.data.data[0]))
        
            }
            if (reqUrl == "/PAG/RanDashboard") {
                console.log("the dispatch is =", response)
         
                dispatch(GetRanSingleProject(response.data.data.tableData[0]))
               
            }

            if (reqUrl === OneRanTech) {
                console.log("the dispatch is =", response)
         
                dispatch(GetRanTechSingleProject(response.data.data.tableData))
               
            }
            
            
            if (reqUrl === "/PAG/OneSiteProjectCode" || reqUrl==="/PAG/ranOneSiteProjectCode"  || reqUrl === "/PAG/OneSiteDatabaseProjectCode") {
                dispatch(FetechProductCode(response.data.data))
                // dispatch(clearclearProjectIddAction())
            }
            if (reqUrl === "/PAG/OneSiteDatabaseprojectId" || reqUrl === "/PAG/ranOneSiteDatabaseprojectId" || reqUrl===networkOneSiteDatabaseprojectId) {

                dispatch(getProjectId(response.data.data))
            }
            if (reqUrl === "/listMops") {
                dispatch(FetechSingleMops(response.data.data))
            }
            if (reqUrl === "/PAG/nestingTime") {
                dispatch(FetechNesting(response.data.data))
            }

            if (reqUrl === "/PAG/nestingTime") {
                dispatch(FetechNesting(response.data.data))
            }

            if (reqUrl === mobileDatacoptl) {
                dispatch(singlemobileDatacoptl(response.data.data))
            }

            

        })
        // .catch((err)=>{
        //     console.log("addAcccountReducerAction error=",err)
        // })
    }
}


export function clearGetSingleProjectDatabase() {

    console.log("i am going to clear")
    return {
        type: FETECH_SINGLE_PROJECTDATABASE,
        payload: []
    }
}

export function clearIxSingleSite(){
    return {
        type:CLEAR_IX_SINGLE_API,
        payload:[]
    }
}
export function clearGetSingleRanProject() {

    console.log("i am going to clear")
    return {
        type: CLEAR_FETECH_SINGLE_RAN_PROJECT,
        payload: []
    }
}

export function clearGetSingleProject() {
    return {
        type: CLEAR_FETECH_SINGLE_MOPS,
        payload: []
    }
}


export function GetIXSingleProject(res) {

    console.log(res,"GetRanSingleProject")
    return {
        type: FETECH_SINGLE_IX_PROJECT,
        payload: res

    }
}

export function ClearSingleIX(res){
    return{
        type: FETECH_SINGLE_IX_PROJECT,
        payload: res
    }
}

export function GetRanSingleProject(res) {

    console.log(res,"GetRanSingleProject")
    return {
        type: FETECH_SINGLE_RAN_PROJECT,
        payload: res

    }
}


export function GetRanTechSingleProject(res) {

    console.log(res,"GetRanSingleProject")
    return {
        type: FETECH_SINGLE_TECH_RAN_PROJECT,
        payload: res

    }
}





export function GetennoProject(res) {
    return {
        type: FETECH_E911_PROJECT,
        payload: res

    }
}


export function GetclearennoProject(res) {
    return {
        type: FETECH_NEW_E911_PROJECT,
        payload: res

    }
}



export function GetLastSavedData(res) {
    return {
        type: Get_Last_Saved_Data,
        payload: res
    }
}

export function SaveLastSavedData(res) {
    return {
        type: Save_Last_Saved_Data,
        payload: res
    }
}


export function GetttProject(res) {
    return {
        type: FETECH_TT_PROJECT,
        payload: res

    }
}

export function GetclearttProject(res) {
    return {
        type: FETECH_CLEAR_TT_PROJECT,
        payload: res

    }
}





export function GetSingleProject(res) {
    console.log(res,"resresresres")
    return {
        type: FETECH_SINGLE_PROJECT,
        payload: res

    }
}

export function GetSingleProjectDatabase(res) {
    return {
        type: FETECH_SINGLE_PROJECTDATABASE,
        payload: res

    }
}


export function GetTimeLineAction(reqUrl, id) {
    let newUrl = reqUrl + id
    console.log("inside getTimeine function function")
    return (dispatch, getState) => {


        common(newUrl).then((response) => {
            console.log("response of single project =", response.data)
            // swal({
            //     title: "Good job!",
            //     text: "Account Added Successfully",
            //     icon: "success",
            //     button: "Ok",
            //   })

            dispatch(TimeLineAction(response.data.data))

        })
            .catch((err) => {
                console.log("addAcccountReducerAction error=", err)
            })
    }
}



export function GetChartAction(reqUrl, id) {
    let newUrl = reqUrl + id
    console.log("inside getTimeine function function")
    return (dispatch, getState) => {


        common(newUrl).then((response) => {
            console.log("response of single project =", reqUrl,"reqUrl",ttCountVendor)
            // swal({
            //     title: "Good job!",
            //     text: "Account Added Successfully",
            //     icon: "success",
            //     button: "Ok",
            //   })
            if(reqUrl===ttCountVendor || reqUrl===sitesCountCustomer){
                dispatch(ttCountVendorChartAction(response.data.data))
            }
            if(reqUrl===dashboardVendor || reqUrl===dashboardCustomer){
                dispatch(dashboardVendorChartAction(response.data.data))
            }
            if(reqUrl===ttAgingVendor || reqUrl===sitesAgingCustomer){
                dispatch(AgingVendorChartAction(response.data.data))
            }
            if(reqUrl===warRoomActivity){
                dispatch(warRoomVendorChartAction(response.data.data))
            }
            if(reqUrl===awsDashboard){
                dispatch(awsChart(response.data.data))
            }
            if(reqUrl===aws_callLogsdb){
                dispatch(awsChart(response.data.data))
            }
            
            if(reqUrl===aws_callLogschartdb){
                dispatch(awsChartCall(response.data.data))
            }

            
            

            // dispatch(ChartAction(response.data.data))

        })
            .catch((err) => {
                console.log("addAcccountReducerAction error=", err)
            })
    }
}
export function ttCountVendorChartAction(res) {
    return {
        type: VENDOR_CHART_TIMELINE,
        payload: res
    }
}


export function assigningEngineerAction(res){
    return (dispatch,getState)=>{
        
        dispatch(setAssignedEngineer(res))
    }
}
export function setAssignedEngineer(res){
    console.log("the rwemlakmclsdkmn=",res)
    return {
        type:SET_ASSINGNED_ENGINEER,
        payload:res
    }
}


export function AgingVendorChartAction(res) {
    return {
        type: TT_AGING_CHART_TIMELINE,
        payload: res
    }
}



export function warRoomVendorChartAction(res) {
    return {
        type: WAR_ROOM_CHART_TIMELINE,
        payload: res
    }
}


export function awsChart(res) {
    return {
        type: AWS_CHART_TIMELINE,
        payload: res
    }
}
export function awsChartCall(res) {
    return {
        type: AWS_CHART_CALL_TIMELINE,
        payload: res
    }
}



export function dashboardVendorChartAction(res) {
    return {
        type: DASHBOARD_VENDOR_CHART_TIMELINE,
        payload: res
    }
}
// export function ChartAction(res) {
//     return {
//         type: CHART_TIMELINE,
//         payload: res
//     }
// }
// export function ChartAction(res) {
//     return {
//         type: CHART_TIMELINE,
//         payload: res
//     }
// }

// export function ChartAction(res) {
//     return {
//         type: CHART_TIMELINE,
//         payload: res
//     }
// }


export function TimeLineAction(res) {
    return {
        type: FETECH_TIMELINE,
        payload: res
    }
}

function addCrNumberAction(res) {
    return {
        type: FETECH_ADD_CR_NUMBER,
        payload: res
    }
}

export function setSSVDashboard(res){
    return {
        type:SSV_DASHBOARD,
        payload:res
    }
}

export function setLaunchSSVDashboard(res){
    return {
        type :LAUNCH_SSVDASHBOARD,
        payload:res
    }
}

export function setLoaderAction(res){
    return {
        type:SET_LOADER,
        payload:res
    }
}